import { ApiError } from '@melio/api-client';
import {
  PostPayorOnboardingRequest,
  PostPayorOnboardingResponse,
  PublicPayorApiClient,
} from '@melio/platform-api-axios-client';
import { useMutation } from 'react-query';

import { useModel, UseModelProps } from '../../api-client';

type UseGuestPayorPaymentRequestDetailsProps = Omit<
  UseModelProps<typeof PublicPayorApiClient.getPaymentRequestDetails>,
  'id'
> & {
  paymentRequestLink: string;
};

export type GuestAuthResponse = PostPayorOnboardingResponse;
export type GuestAuthRequest = PostPayorOnboardingRequest;

export const useGuestPayorPaymentRequestDetails = (props: UseGuestPayorPaymentRequestDetailsProps) =>
  useModel({
    ...props,
    id: props.paymentRequestLink,
    queryKey: 'PublicPayorApi',
    queryFn: PublicPayorApiClient.getPaymentRequestDetails,
  });

export const useGuestPayorOnboarding = () => {
  const { mutateAsync, ...rest } = useMutation<PostPayorOnboardingResponse, ApiError, PostPayorOnboardingRequest>(
    async ({ email, paymentRequestLink }) => {
      const response = await PublicPayorApiClient.postPublicPayorOnboarding({ email, paymentRequestLink });
      return response.data;
    }
  );

  return {
    ...rest,
    onboarding: mutateAsync,
  };
};
